import { isAnnual, isMonthly, isPlanPlus } from "@/react/helpers/planHelpers";
import { isCurrent } from "@/react/helpers/plansHelpers";
import { eligibleForCurrentPlanCredit } from "@/react/helpers/plansHelpers";

import { useAuxiliaryPlans } from "../../../hooks/useAuxiliaryPlans";
import { usePlans } from "../../../RegularPlan/PlansContext";
import { usePlanPricing } from "../../../UpgradePlanDetailsWithProrationModal/hooks/usePlanPricing";
import { AnnualSavings } from "./AnnualSavings";
import { CurrentPlanCredit } from "./CurrentPlanCredit";
import { DiscountCoupon } from "./DiscountCoupon";
import { DueToday } from "./DueToday";
import { MonthlyLoss } from "./MonthlyLoss";
import { PlanSavingsSkeleton } from "./PlanSavingsSkeleton";

export const PlanSavings = () => {
  const { selectedPlan, selectedPlanTier, customPlanOfferPlan } = usePlans();
  const isCustomPlusOffer =
    !!customPlanOfferPlan && isPlanPlus(selectedPlanTier);

  const { auxiliarySelectedPlan, yearlyPlan } = useAuxiliaryPlans();

  // [TODO] For custom Plus offers, skip proration API — it doesn't know the custom price
  // and would compute against the base plan amount. "Due today" is shown from the virtual plan instead.
  const { pricing, isLoadingPricing } = usePlanPricing({
    plan: selectedPlan,
    alternativePlan: isCustomPlusOffer ? undefined : auxiliarySelectedPlan,
    isAnnualPlan: isAnnual(selectedPlan?.interval),
    shouldSkipProration: isCustomPlusOffer,
    isPlanLoading: false,
  });

  if (!selectedPlan) return null;
  if (isCurrent(selectedPlan.plan_action)) return null;

  if (isCustomPlusOffer) {
    return (
      <div className="border-primary flex flex-col gap-y-1 border-t pt-4">
        <DueToday
          dueToday={customPlanOfferPlan.display_total_with_currency_code}
        />
      </div>
    );
  }

  if (isLoadingPricing || !auxiliarySelectedPlan || !yearlyPlan) {
    return <PlanSavingsSkeleton />;
  }

  return (
    <div className="border-primary flex flex-col gap-y-1 border-t pt-4">
      {isAnnual(selectedPlan.interval) && (
        <AnnualSavings selectedPlan={yearlyPlan} />
      )}
      {isMonthly(selectedPlan.interval) && (
        <MonthlyLoss auxiliarySelectedPlan={auxiliarySelectedPlan} />
      )}

      {pricing.currentPlanCredit &&
        eligibleForCurrentPlanCredit(selectedPlan) && (
          <CurrentPlanCredit currentPlanCredit={pricing.currentPlanCredit} />
        )}

      {pricing.discountCoupon && (
        <DiscountCoupon discountCoupon={pricing.discountCoupon} />
      )}

      {pricing.dueToday && <DueToday dueToday={pricing.dueToday} />}
    </div>
  );
};
